import React from "react";
import Select from "react-select";
import {ModalShell} from "../ui/ModalShell";
import {DOW_OPTIONS} from "../constants";
import {ModalMode, SelectOption} from "../types";
import {BtnSpinner} from "../../../../components/fields/BtnSpinner";

export function TemplateModal({
                                  mode,
                                  typeOptions,
                                  typesLabelById,
                                  templateTypeId,
                                  setTemplateTypeId,
                                  templateDepartureDow,
                                  setTemplateDepartureDow,
                                  templateAcceptanceDow,
                                  setTemplateAcceptanceDow,
                                  templateIntervalWeeks,
                                  setTemplateIntervalWeeks,
                                  templatePhase,
                                  setTemplatePhase,
                                  onClose,
                                  onSubmit,
                                  isSaving,
                                  selectMenuPortal,
                              }: {
    mode: ModalMode;

    typeOptions: SelectOption[];
    typesLabelById: (id: number) => string;

    templateTypeId: number | null;
    setTemplateTypeId: (v: number | null) => void;

    templateDepartureDow: SelectOption | null;
    setTemplateDepartureDow: (v: SelectOption | null) => void;

    templateAcceptanceDow: SelectOption | null;
    setTemplateAcceptanceDow: (v: SelectOption | null) => void;

    templateIntervalWeeks: 1 | 2;
    setTemplateIntervalWeeks: (v: 1 | 2) => void;

    templatePhase: 0 | 1;
    setTemplatePhase: (v: 0 | 1) => void;

    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
    isSaving: boolean;

    selectMenuPortal: any;
}) {
    return (
        <ModalShell onClose={onClose}>
            <h2 className="supplies-modal-title">{mode === "create" ? "Добавить шаблон" : "Изменить шаблон"}</h2>

            {mode !== "create" && (
                <div className="supplies-modal-note" style={{
                    marginTop: 10,
                    padding: "10px 12px",
                    borderRadius: 12,
                    background: "#fff7e6",
                    border: "1px solid rgba(0,0,0,0.08)",
                    fontSize: 13,
                    lineHeight: 1.35,
                    opacity: 0.9,
                }}>
                    <b>Важно:</b> при изменении шаблона при необходимости сами удалите планируемую поставку со старыми
                    датами и создайте новую.
                    При необходимости изменения текущих поставок, обратитесь к разработчику.
                </div>
            )}
            <div className="supplies-modal-note" style={{
                marginTop: 10,
                padding: "10px 12px",
                borderRadius: 12,
                background: "#fff7e6",
                border: "1px solid rgba(0,0,0,0.08)",
                fontSize: 13,
                lineHeight: 1.35,
                opacity: 0.9,
            }}>
                Разница между датой приёмки и датой отправки не может превышать 7 дней.
                Например, допустимы значения «понедельник → понедельник», тогда разница между датой приёмки и датой отправки будет 7 дней.
                Если требуется интервал более 7 дней, обратитесь к разработчику.
            </div>
            <form className="supplies-form" onSubmit={onSubmit}>
                <div className="admin-field">
                    <div className="admin_title">Тип</div>

                    <Select
                        {...selectMenuPortal}
                        options={typeOptions}
                        value={
                            templateTypeId
                                ? {value: String(templateTypeId), label: typesLabelById(templateTypeId) || "—"}
                                : null
                        }
                        onChange={(v) => setTemplateTypeId(v ? Number((v as any).value) : null)}
                        classNamePrefix="supplies-select"
                        placeholder="Выберите тип..."
                    />
                </div>

                <div className="supplies-form-row">
                    <div className="admin-field supplies-form-col">
                        <div className="admin_title">День отправки</div>
                        <Select
                            {...selectMenuPortal}
                            options={DOW_OPTIONS}
                            value={templateDepartureDow}
                            onChange={(v) => setTemplateDepartureDow(v as SelectOption)}
                            classNamePrefix="supplies-select"
                        />
                    </div>

                    <div className="admin-field supplies-form-col">
                        <div className="admin_title">День приёмки (до дня отправки)</div>
                        <Select
                            {...selectMenuPortal}
                            options={DOW_OPTIONS}
                            value={templateAcceptanceDow}
                            onChange={(v) => setTemplateAcceptanceDow(v as SelectOption)}
                            classNamePrefix="supplies-select"
                        />
                    </div>
                </div>

                <div className="supplies-form-row">
                    <div className="admin-field supplies-form-col">
                        <div className="admin_title">Интервал</div>
                        <select
                            className="admin-input"
                            value={templateIntervalWeeks}
                            onChange={(e) => setTemplateIntervalWeeks((Number(e.target.value) === 2 ? 2 : 1) as 1 | 2)}
                        >
                            <option value={1}>Еженедельно</option>
                            <option value={2}>Раз в 2 недели</option>
                        </select>
                    </div>

                    <div className="admin-field supplies-form-col">
                        <div className="admin_title">Фаза (только для 2 недель)</div>
                        <select
                            className="admin-input"
                            value={templatePhase}
                            onChange={(e) => setTemplatePhase((Number(e.target.value) === 1 ? 1 : 0) as 0 | 1)}
                            disabled={templateIntervalWeeks !== 2}
                        >
                            <option value={0}>0 — чётные ISO-недели (A)</option>
                            <option value={1}>1 — нечётные ISO-недели (B)</option>
                        </select>

                        <div style={{fontSize: 12, opacity: 0.75, marginTop: 4}}>
                            Фаза нужна, чтобы чередовать поставку “раз в 2 недели”. Фаза 0 — чётные ISO-недели, фаза 1 —
                            нечётные
                            (по номеру недели даты отправки).
                        </div>
                    </div>
                </div>

                <div className="supplies-modal-actions">
                    <button
                        type="button"
                        className="admin-button-secondary admin-button-secondary--ghost"
                        onClick={onClose}
                        disabled={isSaving}
                    >
                        Отмена
                    </button>

                    <button type="submit" className="admin-button-primary" disabled={isSaving}>
                        {isSaving ? (
                            <BtnSpinner/>
                        ) : mode === "create" ? (
                            "Добавить"
                        ) : (
                            "Сохранить"
                        )}
                    </button>
                </div>
            </form>
        </ModalShell>
    );
}
